import React from 'react';
import { messageFormat } from '@clubmed/utils';
import { dateDiff } from 'Components/widgets/trip-date-picker/TripDatePicker.utils';
import { t } from 'Src/i18n';

export type NbNightsProps = {
  from: Date | null | undefined;
  to: Date | null | undefined;
  hovered: Date | null | undefined;
  duration: number | null | undefined;
};

export const NbNights = ({ from, to, hovered, duration }: NbNightsProps) => {
  const computeDisplayedDuration = () => {
    const displayedDuration =
      from && (to || hovered) ? dateDiff(from, to || hovered || from) || duration : 0;
    return displayedDuration || duration || 0;
  };
  const displayedDuration = computeDisplayedDuration();

  const durationLabel = messageFormat({
    n: t('faceting.when.durationPlural'),
    _0: '-',
    _1: t('faceting.when.durationSingular'),
  }).format({
    n: displayedDuration,
    count: displayedDuration,
  });

  return (
    <p data-testid="nbNights" className="pb-10 text-center text-14 font-bold text-black">
      {t('faceting.when.pricesBasedOn')} {durationLabel}
    </p>
  );
};
